(ns common.schema.entities.survey.survey-type
  (:require
   [common.schema.schema-utils :as su]))

(def target-entity-types
  [:entity.type/company
   :entity.type/person
   :entity.type/investor
   :entity.type/oppo
   :entity.type/holding
   :entity.type/real-estate
   :entity.type/fof-asset
   :entity.type/other-asset
   :entity.type/fund
   :entity.type/fundraising-opportunity])

(def schema
  (concat
   (su/name-unique-per-tenant :survey-type/label
                              "Label"
                              :entity.type/survey-type
                              {:system-required? true
                               :system-semantics
                               su/user-provided-system-required-field-semantics})
   (su/keyword-multi-field :survey-type/entity-types
                           "Target types"
                           target-entity-types
                           {:default-field-visibility :in-use-disabled
                            :mandatory-config         :mandatory/always
                            :system-required?         true
                            :system-semantics
                            su/user-provided-system-required-field-semantics})
   (su/multi-ref-field :survey-type/teams-access "Teams" [:entity.type/team] {:default-field-visibility :in-use-disabled})
   (su/multi-ref-field :survey-type/rotation-periods
                       "Rotation periods"
                       [:entity.type/rotation-period]
                       {:default-field-visibility :in-use-disabled
                        :editor-type              :editor.type/none
                        :grid-type                :editor.type/none
                        :filter-type              :filter.type/none})
   (su/multi-ref-field :survey-type/reminder-rules
                       "Reminder rules"
                       [:entity.type/reminder-rule]
                       {:default-field-visibility :in-use-disabled
                        :editor-type              :editor.type/none
                        :grid-type                :editor.type/none
                        :filter-type              :filter.type/none})
   (su/multi-ref-field :survey-type/survey-cycles
                       "Survey cycles"
                       [:entity.type/survey-cycle]
                       {:default-field-visibility :in-use-disabled
                        :editor-type              :editor.type/none
                        :grid-type                :editor.type/none
                        :filter-type              :filter.type/none})))
